
export const REGISTRATION_INITIAL = "REGISTRATION_INITIAL";
export const REGISTRATION_CONFIRM= "REGISTRATION_CONFIRM";
export const REGISTRATION_COMPLETE = "REGISTRATION_COMPLETE";

// restore password
export const REGISTRATION_RESTORE = "REGISTRATION_RESTORE";